<template>
  <section class="section Messages">
    <div class="container">
      <div class="level">
        <h1 class="title level-left">Mensajes</h1>
      </div>
      <div class="card empty" v-if="!messagesList.length">
        <div class="empty_wrapper">
          <img src="@/assets/img/empty_messages.svg">
          <p> Todavia no hay mensajes </p>
        </div>
      </div>
      <div v-else class="card">
        <table class="table">
          <thead>
            <tr>
              <th>dni</th>
              <th>nombre</th>
              <th>telefono</th>
              <th>asunto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in messagesList"  :key="message.id">
              <td>{{message.dni}}</td>
              <td>{{message.names}}</td>
              <td>{{message.phone}}</td>
              <td>{{message.subject}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { firestore } from '@/main'
export default {
  data: () => ({
    messagesList: []
  }),
  mounted () {
    this.getAllmessages()
  },
  methods: {
    getAllmessages () {
      firestore.collection("contact").get()
      .then((snap) => {
        snap.forEach((doc) => {
          const data = doc.data()
          this.messagesList.push({
            id: doc.id,
            names: data.names,
            phone: data.phone,
            subject: data.subject,
            dni: data.dni
          })
        })
      })
      .catch(console.error)
    },
  },
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../../assets/css/_variables.sass'
.Messages
  .modal-content
    width: 400px
    .new_message
      padding: 40px
      display: grid
      grid-template-columns: 1fr
      grid-gap: 20px
  .button, .input
    box-sizing: border-box
  h2
    font-weight: 700
  h1
    font-size: 20px
  table
    width: 100%
  .empty
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    min-height: 300px
    .empty_wrapper
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      p
        text-align: center
        font-weight: 500
        margin-top: 20px
        font-size: 14px
      img
        width: 150px
        margin-right: -10px
</style>